import { w as X } from "../../withTheme-zx3wTAWo.es.js";
import a, { useState as c } from "react";
import m from "prop-types";
import { a as f } from "../../propTypes-DVvgo52A.es.js";
import { u as j } from "../../utils-C0l876fA.es.js";
import { b as h, s as z, d as W, a as K } from "../../utils-B8CGXZ5v.es.js";
import { D as L } from "../../DateInputRow-BSqa13dI.es.js";
import { D as Y } from "../../DateRangeList-DcXypSbP.es.js";
import { D as G } from "../../DayPicker-BTgVNC2J.es.js";
import { M as H } from "../../MonthPicker-DVwW-q2g.es.js";
import { B } from "../../Button-CY2D4L2H.es.js";
import '../../index4.css';const J = "DatePickerPanel-module__container___f810T", Q = "DatePickerPanel-module__detailContainer___wiXMD", U = "DatePickerPanel-module__buttonContainer___VMbKc", Z = "DatePickerPanel-module__button___atbyF", p = "DatePickerPanel-module__pickerContainer___X9Rzn", r = {
  container: J,
  "flex-container": "DatePickerPanel-module__flex-container___rSYqe",
  detailContainer: Q,
  buttonContainer: U,
  button: Z,
  pickerContainer: p
}, C = (e) => {
  const _ = (t, n) => n === "start" ? !(e.minDate && h(t, e.showDays) < h(e.minDate, e.showDays)) : !(e.maxDate && h(t, e.showDays) > h(e.maxDate, e.showDays)), b = (t, n) => t ? _(t, n) ? t : n === "start" ? e.minDate : e.maxDate : null, [i, y] = c(b(e.start, "start")), [o, x] = c(b(e.end, "end")), [I, E] = c(null), [P, d] = c(null), [S, u] = c(null), [g, T] = c(null), { t: N } = j(), w = (t, n) => {
    let s = !0;
    if (_(t, "start"))
      d(null);
    else {
      const l = `The earliest date allowed is ${W(
        e.minDate,
        e.showDays
      )}`;
      d(l), s = !1;
    }
    if (_(n, "end"))
      u(null);
    else {
      const l = `The latest date allowed is ${W(
        e.maxDate,
        e.showDays
      )}`;
      u(l), s = !1;
    }
    return t && n && !K(t, n) && (T(
      N("The end date must be later than the start date.")
    ), s = !1), s;
  }, k = (t) => {
    t === "start" ? d(null) : u(null), T(null);
  }, M = (t, n = !1) => {
    w(t, o) && (k("start"), y(t), n || E(null));
  }, q = (t, n = !1) => {
    w(i, t) && (k("end"), x(t), n || E(null));
  }, V = (t, n) => {
    t === "start" ? d(n) : u(n);
  }, F = (t, n) => {
    t === "start" ? y(n) : x(n);
  }, v = (t, n) => {
    const { err: s, date: l } = z(t, e.showDays);
    s ? V(n, s) : (F(n, l), w(n === "end" ? i : l, n === "end" ? l : o) && k(n));
  }, O = (t) => {
    v(t, "start");
  }, $ = (t) => {
    v(t, "end");
  }, R = {
    start: i,
    end: o,
    onSetStart: M,
    onSetEnd: q,
    minDate: e.minDate,
    maxDate: e.maxDate,
    rangeMode: !0,
    focused: I,
    theme: e.theme
  }, D = [];
  (P || g) && D.push("from:-error-message"), S && D.push("to:-error-message");
  const A = D.length > 0 ? D.join(" ") : void 0;
  return /* @__PURE__ */ a.createElement("div", { className: r.container }, /* @__PURE__ */ a.createElement("div", { className: r["flex-container"] }, /* @__PURE__ */ a.createElement(
    Y,
    {
      onSelect: (t, n) => e.onSetRange(t, n),
      showDays: e.showDays,
      minDate: e.minDate,
      maxDate: e.maxDate,
      appendElement: e.appendElement,
      theme: e.theme
    }
  ), /* @__PURE__ */ a.createElement("div", { className: r.detailContainer }, /* @__PURE__ */ a.createElement(
    L,
    {
      start: i,
      end: o,
      showDays: e.showDays,
      startWarning: P || g,
      endWarning: S,
      onSetStart: O,
      onSetEnd: $,
      onSetFocus: E,
      theme: e.theme
    }
  ), /* @__PURE__ */ a.createElement("div", { className: r.pickerContainer }, e.showDays ? /* @__PURE__ */ a.createElement(G, { ...R }) : /* @__PURE__ */ a.createElement(H, { ...R })), /* @__PURE__ */ a.createElement("div", { className: r.buttonContainer }, /* @__PURE__ */ a.createElement("div", { className: r.button }, /* @__PURE__ */ a.createElement(
    B.CancelButton,
    {
      handleClick: e.onClose,
      theme: e.theme
    }
  )), /* @__PURE__ */ a.createElement("div", { className: r.button }, /* @__PURE__ */ a.createElement(
    B.ActionButton,
    {
      theme: e.theme,
      handleClick: () => e.onSetRange(i, o),
      disabled: !!P || !!S || !!g || !i || !o,
      ariaDescribedBy: A
    },
    "Accept"
  ))))));
};
C.defaultProps = {
  theme: "default",
  minDate: null,
  maxDate: null,
  appendElement: null,
  start: null,
  end: null
};
C.propTypes = {
  start: f,
  end: f,
  showDays: m.bool.isRequired,
  onSetRange: m.func.isRequired,
  onClose: m.func.isRequired,
  theme: m.string,
  minDate: f,
  maxDate: f,
  appendElement: m.node
};
const fe = X(C);
export {
  fe as default
};
